import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; 
import "./Materials.css";
import { FaChevronRight, FaCloudUploadAlt } from "react-icons/fa";
import estbnLogo from "../../assets/svg/ESTBNLOGO.svg";
import sos from "../../assets/svg/Sos.svg"; 
import key from '../../assets/svg/wrench (1) 1.svg'; 


const AssistanceRequest = ({ onBack }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = () => {
    setShowSuccess(true);
  };

  return (
    <div className="mat-ord-form-container" dir="rtl">
      <header className="mat-ord-form-header">
        {!showSuccess && (
            <FaChevronRight className="back-icon" onClick={onBack} />
        )}
        <h3>طلب مساعدة عاجلة</h3>
      </header>

      <div className="mat-ord-form-body">
        <div className="mat-ord-form-group">
          <label className="mat-ord-label">:حدد نوع المشكله</label>
          <div className="mat-ord-radio-group">
            <label className="mat-ord-radio-item">
              <span>عطل في العربية</span>
              <input type="radio" name="problem" />
            </label>
            <label className="mat-ord-radio-item">
              <span>حادث</span>
              <input type="radio" name="problem" />
            </label>
            <label className="mat-ord-radio-item">
              <span>العميل غير متواجد</span>
              <input type="radio" name="problem" />
            </label>
            <label className="mat-ord-radio-item">
              <span>مشادة / مشكلة في الطريق</span>
              <input type="radio" name="problem" />
            </label>
            <label className="mat-ord-radio-item">
              <span>أخرى</span>
              <input type="radio" name="problem" />
            </label>
          </div>
        </div>

        <div className="mat-ord-form-group">
          <label className="mat-ord-label">وصف المشكله</label>
          <textarea 
            className="mat-ord-textarea" 
            placeholder="أدخل تفاصيل المشكلة"
            rows="4"
          ></textarea>
        </div>

        <div className="mat-ord-form-group">
          <label className="mat-ord-label">ارفع صورة توضح المشكله</label>
          <div className="mat-ord-upload-box">
            <div className="mat-ord-upload-content">
              <FaCloudUploadAlt size={30} color="#555" />
              <span className="mat-ord-upload-title">اضف ملف</span>
              <span className="mat-ord-upload-subtitle">أرفق صورة، فيديو، أو تسجيل صوتي.</span>
            </div>
            <input type="file" className="mat-ord-file-hidden" />
          </div>
        </div>

        <div className="mat-ord-checkbox-container">
          <label className="mat-ord-checkbox-label">
            <span>ارسال موقعي لأستبن</span>
            <input type="checkbox" defaultChecked />
            <span className="checkmark"></span>
          </label>
        </div>
      </div>

      <div className="mat-ord-form-footer">
        <button className="mat-ord-submit-btn" onClick={handleSubmit}>
            ارسال طلب المساعده
        </button>
      </div>

      {showSuccess && (
        <div className="mat-ord-modal-overlay">
          <div className="mat-ord-modal-content mat-ord-success-modal">
            <h2 className="mat-ord-success-title">تم إرسال طلب المساعدة بنجاح</h2>
            <p className="mat-ord-success-text">
              تم استلام طلبك بنجاح بواسطة فريق "استبن"، <br/>
              وجاري متابعة حالتك الآن. سيتم التواصل معك في <br/>
              أقرب وقت ممكن عبر التطبيق أو الهاتف <br/>
              الموقع الحالي تم تسجيله تلقائيًا مع الطلب.
            </p>
            <button className="mat-ord-success-btn" onClick={onBack}>
              الذهاب للصفحه الرئيسيه
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// 2. MAIN COMPONENT 
// ==========================================
const MaterialsForOrders = () => {
  const navigate = useNavigate(); 

  // --- STATE ---
  const [currentView, setCurrentView] = useState('dashboard');
  const [isShiftActive, setIsShiftActive] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const [isSummaryVisible, setIsSummaryVisible] = useState(false);

  // --- HANDLERS ---
  const handleShiftButtonClick = (e) => {
    e.stopPropagation();
    if (isShiftActive) {
      setActiveModal("end");
    } else {
      setActiveModal("start");
    }
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const handleStartShiftConfirm = () => {
    setIsShiftActive(true);
    closeModal();
  };

  const handleEndShiftConfirm = () => {
    setIsShiftActive(false);
    setIsSummaryVisible(false);
    closeModal();
  };

  const handleShiftStatusClick = () => console.log("Shift Status Card Clicked!");
  const handleToolReviewClick = () => console.log("Tool Review Card Clicked!");
  
  // ----------------------------------------------------
  // UPDATED FUNCTION HERE
  // ----------------------------------------------------
  const handleViewToolsClick = (e) => {
    e.stopPropagation();
    navigate("/checkingtools"); // Navigate to checkingtools route
  };
  
  const handleTodayOrdersClick = () => console.log("Today Orders Card Clicked!");
  
  const handleViewAllOrdersClick = (e) => {
    e.stopPropagation();
    navigate("/dayOrders"); 
  };
  
  const handleRequestAssistanceClick = () => {
    setCurrentView('assistance');
  };
  
  const handleSendRequestClick = (e) => {
    e.stopPropagation();
    setCurrentView('assistance');
  };

  const handleBackToDashboard = () => {
    setCurrentView('dashboard');
  };

  // --- CONDITIONAL RENDERING ---
  if (currentView === 'assistance') {
    return <AssistanceRequest onBack={handleBackToDashboard} />;
  }

  return (
    <div className="mat-ord-container">
      <header className="mat-ord-main-header">
        <img src={estbnLogo} alt="ESTBN Logo" className="mat-ord-logo" />
        <div className="mat-ord-welcome">
          <h4>مرحباً احمد 👋</h4>
          <p>ابدأ يوم جديد بكل نشاط وحيوية</p>
        </div>
      </header>

      <div className="mat-ord-content-wrapper">
        {/* Card 1: Shift Status */}
        <div className="mat-ord-card mat-ord-shift-card" onClick={handleShiftStatusClick}>
          <div className="mat-ord-card-header">
            <p>{isShiftActive ? "أنت على رأس عملك" : "لم تبدأ الشيفت بعد"}</p>
            <div className="mat-ord-user-icon">👤</div>
          </div>
          <p className="mat-ord-card-desc">
            {isShiftActive
              ? "يمكنك الآن استقبال الطلبات"
              : "ابدأ الشيفت بصورة الحضور لعرض الطلبات"}
          </p>
          <button
            className="mat-ord-btn mat-ord-btn-start"
            onClick={handleShiftButtonClick}
          >
            {isShiftActive ? "انهاء الشيفت" : "ابدأ الشيفت"}
            {!isShiftActive && <span style={{ marginLeft: "5px" }}>▶</span>}
          </button>
        </div>

        {/* Card 2: Tool Review */}
        <div className="mat-ord-card mat-ord-tool-card" onClick={handleToolReviewClick}>
          <div className="mat-ord-badge">1</div>
          <img src={key} alt="Wrench Icon" className="mat-ord-tool-icon" />
          <div className="mat-ord-tool-text">
            <h3 className="mat-ord-card-title">مراجعة الأدوات على السيارة #204</h3>
            <p className="mat-ord-card-desc">
              راجع حالة الأدوات التي أقربها الفني. تأكد من توفرها وسلامتها قبل
              تحرك السيارة. في حال وجود كسر أو نقص، أضف ملاحظتك.
            </p>
            {/* Added Click Handler here */}
            <div className="mat-ord-action-link" onClick={handleViewToolsClick}>
              مراجعه الادوات <span style={{ marginRight: "5px" }}>‹</span>
            </div>
          </div>
        </div>

        {/* Card 3: Today's Orders */}
        <div className="mat-ord-card mat-ord-today-card" onClick={handleTodayOrdersClick}>
          <div className="mat-ord-badge">1</div>
          <div className="mat-ord-card-header">
            <h3 className="mat-ord-card-title">طلبات اليوم</h3>
            <div className="mat-ord-action-link" onClick={handleViewAllOrdersClick}>
              عرض جميع الطلبات <span style={{ marginRight: "5px" }}>‹</span>
            </div>
          </div>
          <p>عدد الطلبات: <strong>6</strong> طلبات</p>
          <p>الطلبات المنفذة: <strong>0</strong> طلب</p>
          <p>الطلب القادم: <strong>#ORD-3247</strong></p>
          <p>العنوان: مدينة نصر، شارع الطيران، عمارة <strong>۱۸</strong></p>
          <p>الوقت المتوقع: <strong>1:30</strong> مساء</p>
        </div>

        {/* Card 4: Request Assistance */}
        <div
          className="mat-ord-card mat-ord-assist-card"
          onClick={handleRequestAssistanceClick}
        >
          <div className="mat-ord-assist-top">
            <div className="requestAssistanceTextContent">
              <h3 className="mat-ord-card-title">طلب مساعدة على الطريق</h3>
              <p className="mat-ord-card-desc">
                واجهت مشكلة؟ أرسل بلاغ سريع لفريق الدعم
              </p>
            </div>
            <img src={sos} alt="Emergency SOS Icon" className="mat-ord-sos-icon"/>
          </div>
          <button
            className="mat-ord-btn mat-ord-btn-request"
            onClick={handleSendRequestClick}
          >
            أرسل طلب مساعدة
          </button>
        </div>
      </div>

      {/* Start Shift Modal */}
      {activeModal === "start" && (
        <div className="mat-ord-modal-overlay" onClick={closeModal}>
          <div className="mat-ord-modal-content" onClick={(e) => e.stopPropagation()}>
            <h2 className="mat-ord-modal-title">ابدأ الشيفت</h2>
            <div className="mat-ord-modal-body">
              <p>هل أنت متأكد أنك تريد بدء الشيفت الآن؟</p>
              <p>سيتم التقاط صورة لإثبات الحضور، ولن تتمكن من تنفيذ الطلبات بدونها.</p>
            </div>
            <div className="mat-ord-modal-actions">
              <button className="mat-ord-modal-btn secondary" onClick={closeModal}>إلغاء</button>
              <button className="mat-ord-modal-btn primary" onClick={handleStartShiftConfirm}>ابدأ الشيفت</button>
            </div>
          </div>
        </div>
      )}

      {/* End Shift Modal */}
      {activeModal === "end" && (
        <div className="mat-ord-modal-overlay" onClick={closeModal}>
          <div className="mat-ord-modal-content" onClick={(e) => e.stopPropagation()}>
            <h2 className="mat-ord-modal-title">انهاء الشيفت</h2>
            <div className="mat-ord-modal-body">
              <p>هل تريد إنهاء الشيفت الآن؟</p>
              <p>سيتم التقاط صورة لإثبات المغادرة، وسيتم تسجيل كل الرحلات التي تم تنفيذها.</p>

              <div className="mat-ord-summary-toggle" onClick={() => setIsSummaryVisible(!isSummaryVisible)}>
                <span>عرض ملخص الشيفت</span>
                <span className={`mat-ord-summary-arrow ${isSummaryVisible ? "open" : ""}`}>^</span>
              </div>

              {isSummaryVisible && (
                <ul className="mat-ord-summary-details">
                  <li>عدد الطلبات المنفذة: 5</li>
                  <li>الوقت المستغرق: 6 ساعات و10 دقائق</li>
                  <li>عدد البلاغات (SOS): 0</li>
                  <li>آخر موقع: التجمع الخامس</li>
                </ul>
              )}
            </div>
            <div className="mat-ord-modal-actions">
              <button className="mat-ord-modal-btn secondary" onClick={closeModal}>إلغاء</button>
              <button className="mat-ord-modal-btn primary" onClick={handleEndShiftConfirm}>انهي الشيفت</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MaterialsForOrders;